import { getTagStyle } from './utils'

interface TagProps {
  text: string
}

const Tag: React.FC<TagProps> = ({ text }) => {
  const style = getTagStyle(text)

  return (
    <span
      style={{
        backgroundColor: style.bg,
        color: style.color,
        padding: '4px 10px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 500,
        display: 'inline-block',
        marginRight: '6px',
        marginBottom: '6px',
      }}
    >
      {text}
    </span>
  )
}

export default Tag
